import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IError, IFetchPayload } from "../../../interfaces/base";
import { IFetchUsersState } from "../../../interfaces/store/users-interfaces";
import { PAGE_SIZE } from "../../../common/config";

const initialState: IFetchUsersState = {
  users: [],
  loading: false,
  error: null,
  requestState: "prepare",
  operation: null,
  metadata: {
    total: 0,
    page: 0,
  },
  tableState: {
    search: "",
    sort: {
      sortBy: "updatedAt",
      sortOrder: -1,
    },
    pagination: {
      page: 0,
      limit: PAGE_SIZE,
      skip: 0,
    },
  },
};

const _fetchUsersStart = (
  state: IFetchUsersState,
  { payload }: PayloadAction<IFetchPayload>
) => {
  state.loading = true;
  state.error = null;
  state.requestState = "start";
  state.operation = "read";
  state.tableState.search = payload.search;
  state.tableState.sort = payload.sort;
  state.tableState.pagination = payload.pagination;
};

const _fetchUsersSuccess = (
  state: IFetchUsersState,
  { payload }: PayloadAction<any>
) => {
  state.users = payload.data.data;
  state.metadata = payload.data.metadata;
  state.loading = false;
  state.error = null;
  state.requestState = "finish";
};

const _fetchUsersFailed = (
  state: IFetchUsersState,
  { payload }: PayloadAction<IError>
) => {
  state.loading = false;
  state.error = payload;
  state.requestState = "error";
};

const _resetUsers = () => {
  return { ...initialState };
};

const UsersSlice = createSlice({
  name: "users",
  initialState,
  reducers: {
    fetchUsersStart: _fetchUsersStart,
    fetchUsersSuccess: _fetchUsersSuccess,
    fetchUsersFailed: _fetchUsersFailed,
    resetUsers: _resetUsers,
  },
});

export const {
  fetchUsersStart,
  fetchUsersSuccess,
  fetchUsersFailed,
  resetUsers,
} = UsersSlice.actions;
export default UsersSlice.reducer;
